import type { HowCarePlansWorkSlide } from "./types";

export const SUPPORT_EMAIL = "support@eo.care";
export const RETURNS_EMAIL = "returns@eo.care";
export const MESSAGE_CENTER_FAQ_ITEM_ID = 6;

// Tab-scoped, short-lived. Written by the OIDC return page on the
// onboarding-token success path; cleared by usePersonify once the
// /onboarding/exchange has completed (or on any failure / silent re-auth).
export const ONBOARDING_TOKEN_STORAGE_KEY = "oidc_onboarding_token";

export const howCarePlansWorkSlides: HowCarePlansWorkSlide[] = [
  {
    id: 1,
    title: "Tell Us About You",
    description:
      "Answer a few quick questions about your symptoms, use goals, medical record, other meds in use and your daily schedule.",
    imageUrl: "/assets/images/how-care-plans-work-1.png",
  },
  {
    id: 2,
    title: "Receive Your Plan",
    description:
      "Get personalized product, dose and use guidance with clear explanations for every recommendation.",
    imageUrl: "/assets/images/how-care-plans-work-2.png",
  },
  {
    id: 3,
    title: "Try Your Products",
    description:
      "All recommended products are clinician designed, precisely dosed and affordably priced. They're federally legal and ship right to your door.",
    imageUrl: "/assets/images/how-care-plans-work-3.png",
  },
  {
    id: 4,
    title: "Get Updates & Support",
    description:
      "We'll check in regularly to get your feedback and tune your plan. And you can message our expert team anytime. For free.",
    imageUrl: "/assets/images/how-care-plans-work-4.png",
  },
];

export const VIMEO_VIDEOS = {
  HOW_CARE_PLANS_WORK: {
    id: "1125314199",
    hash: "22f6f68a5a",
  },
};

export const CART_ORIGIN = {
  CAREPLAN: "careplan",
  POST_PURCHASE: "post-purchase",
} as const;
